Rot13 = {
  map: null,
  init: function() {
    if (Rot13.map != null) {
        return;
    }

    var e = new Array;
    var t = "abcdefghijklmnopqrstuvwxyz";
    for (i = 0; i < t.length; i++) {
        e[t.charAt(i)] = t.charAt((i + 13) % 26);
    }
    for (i = 0; i < t.length; i++) {
        e[t.charAt(i).toUpperCase()] = t.charAt((i + 13) % 26).toUpperCase();
    };

    Rot13.map = e;
  },
  convert: function(e) {
    Rot13.init();

    var t = "";
    for (i = 0; i < e.length; i++) {
      var n = e.charAt(i);
      t += n >= "A" && n <= "Z" || n >= "a" && n <= "z" ? Rot13.map[n] : n;
    }

    return t;
  },
  write: function(e, id) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
      var currentScript = document.getElementById(id);
      currentScript.insertAdjacentHTML('afterend', Rot13.convert(e));
    } else {
      document.write(Rot13.convert(e));
    }

  }
}



$(document).ready(function () {
  ('use strict');

  // Menú: afegim botó i ocultem menú quan hi ha js
  $('#menu')
    .before(
      '<button class="hamburger hamburger--squeeze" type="button" aria-expanded="false" aria-controls="menu"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="visually-hidden">Menú</span></button>'
    )
    .attr('hidden', 'true');

  // ----
  // menú (https://polypane.rocks/blog/the-perfect-responsive-menu-2019/)
  // ----
  var toggleMenu = document.querySelector('.navigation button');
  var menu = document.querySelector('#menu');

  toggleMenu.addEventListener('click', function () {
    var open = JSON.parse(toggleMenu.getAttribute('aria-expanded'));
    toggleMenu.setAttribute('aria-expanded', !open);
    menu.hidden = !menu.hidden;
  });

  $('.hamburger').on('click', function () {
    // afegir classe al botó
    $(this).toggleClass('is-active');
    // afegir classe al body
    $('body').toggleClass('js-menu-open');
  });

  // ---------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // ---------

  // bind a click event to the 'skip' link
  $('.skip-link').click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = '#' + this.href.split('#')[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr('tabindex', -1)
      .on('blur focusout', function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr('tabindex');
      })
      .focus(); // focus on the content container
  });

  // ----------
  // scroll top
  // ----------
  // $(window).scroll(function () {
  //   if ($(this).scrollTop() > 400) {
  //     $(".scrolltop").addClass("is-visible");
  //   } else {
  //     $(".scrolltop").removeClass("is-visible");
  //   }
  // });

  // ------
  // slider
  // ------
  $('.slider').slick({
    infinite: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 10000,
  });

  $('.slider-responsable').slick({
    arrows: false,
    dots: true,
  });

  // --------
  // headroom
  // --------
  $('body:not(.home) .main-header').headroom({
    offset: 205,
    tolerance: 5,
    classes: {
      initial: 'animated',
      pinned: 'slideDown',
      unpinned: 'slideUp',
    },
  });

  // -----------
  // A11y toggle
  // -----------
  document.addEventListener('DOMContentLoaded', function () {
    initA11yToggle();
    document.addEventListener('DOMSubtreeModified', function () {
      initA11yToggle();
    });
  });

  // ---------------
  // Advanced search
  // ---------------
  $('.button--filters').magnificPopup({
    type: 'inline',
    preloader: false,
    focus: '#type',

    // When element is focused, some mobile browsers in some cases zoom in
    // It looks not nice, so we disable it:
    callbacks: {
      beforeOpen: function () {
        if ($(window).width() < 700) {
          this.st.focus = false;
        } else {
          this.st.focus = '#type';
        }
      },
    },
  });

  // Clear textarea
  $('.advanced-search .button--secondary').click(function () {
    $('#advanced-search').find('textarea').val('');
  });

  // -------------
  // Home counters
  // -------------
  $('.count').each(function () {
    var element = $(this);
    element.addClass('hidden');
    element.viewportChecker({
      classToAdd: 'visible',
      callbackFunction: function () {
        element.prop('Counter', 0).animate(
          {
            Counter: element.text(),
          },
          {
            duration: 2000,
            easing: 'swing',
            step: function (now) {
              element.text(Math.ceil(now));
            },
          }
        );
      },
    });
  });

  // -------------
  // Home ODS
  // -------------
  const odsItems = document.querySelectorAll('.ods-item');

  if (odsItems.length > 0) {

      odsItems.forEach(item => {
          item.addEventListener('click', function (e) {
              e.stopPropagation();

              // tanca tots els altres
              odsItems.forEach(el => {
                  if (el !== item) el.classList.remove('active');
              });

              // toggle actual
              item.classList.toggle('active');
          });
      });

      // evitar que clicar dins el tooltip el tanqui
      document.querySelectorAll('.ods-data').forEach(el => {
          el.addEventListener('click', e => e.stopPropagation());
      });

      // click fora = tanca tot
      document.addEventListener('click', () => {
          odsItems.forEach(el => el.classList.remove('active'));
      });
  }

  // ------------------------
  // Stakeholders read more modal
  // ------------------------
  document.querySelectorAll('.read-more-wrapper').forEach(function (wrapper) {
    var openLink = wrapper.querySelector('.open-modal');
    var overlay = wrapper.querySelector('.modal-overlay');
    var closeButton = wrapper.querySelector('.close-modal');

    if (!openLink || !overlay || !closeButton) {
      return;
    }

    var closeModal = function () {
      overlay.hidden = true;
      document.body.classList.remove('modal-open');
      openLink.focus();
    };

    openLink.addEventListener('click', function (e) {
      e.preventDefault();
      overlay.hidden = false;
      document.body.classList.add('modal-open');
      closeButton.focus();
    });

    closeButton.addEventListener('click', closeModal);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) {
        closeModal();
      }
    });
  });

  // ----------
  // Checkboxes (https://codepen.io/chriscoyier/pen/JYyXjX)
  // ----------
  $('.checks-list input[type="checkbox"]').change(function (e) {
    var container = $(this).closest('li');

    container.find('input[type="checkbox"]').prop({
      indeterminate: false,
      checked: $(this).prop('checked'),
    });

    container.parents('li').each(function () {
      var notChecked = $(this)
        .find('ul input[type="checkbox"]')
        .not(':checked').length;
      var all = $(this).find('ul input[type="checkbox"]').length;
      console.log({
        all: all,
        notChecked: notChecked,
      });
      if (notChecked == 0) {
        $(this)
          .children('div.has-dropdown, label')
          .find('input[type="checkbox"]')
          .prop({
            indeterminate: false,
            checked: true,
          });
      } else if (all == notChecked) {
        $(this)
          .children('div.has-dropdown, label')
          .find('input[type="checkbox"]')
          .prop({
            indeterminate: false,
            checked: false,
          });
      } else {
        $(this)
          .children('div.has-dropdown, label')
          .find('input[type="checkbox"]')
          .prop({
            indeterminate: true,
            checked: false,
          });
      }
    });
  });

  // ------
  // Pop-up
  // ------
  $('.popup-trigger').magnificPopup();

  // ----
  // Tabs https://inclusive-components.design/tabbed-interfaces/
  // ----
  // if ($(".tabbed").length > 0) {
  //   $(".tabbed").each(function (index, element) {
  //     // Get relevant elements and collections
  //     var tabbed = element;
  //     var tablist = tabbed.querySelector("ul.tab-menu");
  //     var tabs = tablist.querySelectorAll("a");
  //     var panels = tabbed.querySelectorAll(".panel");

  //     // The tab switching function
  //     var switchTab = function switchTab(oldTab, newTab) {
  //       newTab.focus(); // Make the active tab focusable by the user (Tab key)

  //       newTab.removeAttribute("tabindex"); // Set the selected state

  //       newTab.setAttribute("aria-selected", "true");
  //       oldTab.removeAttribute("aria-selected");
  //       oldTab.setAttribute("tabindex", "-1"); // Get the indices of the new and old tabs to find the correct
  //       // tab panels to show and hide

  //       var index = Array.prototype.indexOf.call(tabs, newTab);
  //       var oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
  //       panels[oldIndex].hidden = true;
  //       panels[index].hidden = false;
  //     }; // Add the tablist role to the first <ul> in the .tabbed container

  //     tablist.setAttribute("role", "tablist"); // Add semantics are remove user focusability for each tab

  //     Array.prototype.forEach.call(tabs, function (tab, i) {
  //       tab.setAttribute("role", "tab");
  //       //	    tab.setAttribute("id", "tab" + (i + 1));
  //       tab.setAttribute("tabindex", "-1");
  //       tab.parentNode.setAttribute("role", "presentation"); // Handle clicking of tabs for mouse users

  //       tab.addEventListener("click", function (e) {
  //         e.preventDefault();
  //         var currentTab = tablist.querySelector("[aria-selected]");

  //         if (e.currentTarget !== currentTab) {
  //           switchTab(currentTab, e.currentTarget);
  //         }
  //       }); // Handle keydown events for keyboard users

  //       tab.addEventListener("keydown", function (e) {
  //         // Get the index of the current tab in the tabs node list
  //         var index = Array.prototype.indexOf.call(tabs, e.currentTarget); // Work out which key the user is pressing and
  //         // Calculate the new tab's index where appropriate

  //         var dir =
  //           e.which === 37
  //             ? index - 1
  //             : e.which === 39
  //               ? index + 1
  //               : e.which === 40
  //                 ? "down"
  //                 : null;

  //         if (dir !== null) {
  //           e.preventDefault(); // If the down key is pressed, move focus to the open panel,
  //           // otherwise switch to the adjacent tab

  //           dir === "down"
  //             ? panels[i].focus()
  //             : tabs[dir]
  //               ? switchTab(e.currentTarget, tabs[dir])
  //               : void 0;
  //         }
  //       });
  //     }); // Add tab panel semantics and hide them all

  //     Array.prototype.forEach.call(panels, function (panel, i) {
  //       panel.setAttribute("role", "tabpanel");
  //       panel.setAttribute("tabindex", "-1");
  //       var id = panel.getAttribute("id");
  //       panel.setAttribute("aria-labelledby", tabs[i].id);
  //       panel.hidden = true;
  //     }); // Initially activate the first tab and reveal the first tab panel

  //     tabs[0].removeAttribute("tabindex");
  //     tabs[0].setAttribute("aria-selected", "true");
  //     panels[0].hidden = false;
  //   });
  // }
});
